@if (headerBlock(); as headerBlock) {
    <packbo-header-block [headerBlock]="headerBlock" />
}

<div class="mx-auto mb-8 flex w-full flex-col justify-center sm:px-10">
    <packbo-search
        class="mb-8 w-full content-center place-self-center sm:w-91.5 lg:w-full"
        [(searchValue)]="searchValue"
        [(postalCode)]="postalCode"
        [(distance)]="distance"
        [(isEcoFriendly)]="isEcoFriendly"
        [(selectedCertificationsIds)]="selectedCertificationsIds"
        [inputResultsLength]="suppliers().length"
        [inputItemsCertifications]="itemsCertifications()"
        [inputSearchType]="'supplier'"
        [hideSubcategory]="true"
        (outputSearch)="getSuppliers($event)"
    />
    <packbo-supplier-card-shimmer [class.hidden]="!shouldShowShimmer()" />

    <div
        class="xs:w-full flex content-center justify-center place-self-center sm:w-fit lg:w-full"
        [class.hidden]="shouldShowShimmer()"
    >
        @if (suppliers().length) {
            <packbo-supplier-card
                class="flex w-full flex-col items-center justify-center gap-3"
                [suppliers]="suppliers()"
                [postalCode]="postalCode()"
                (allImagesLoaded)="onSupplierImagesLoaded()"
            />
        } @else {
            <ng-container *ngTemplateOutlet="emptyState" />
        }
    </div>

    @if (shouldShowPagination()) {
        <div class="mt-auto">
            <packbo-paginator [(currentPage)]="currentPage" [totalPages]="pagination().totalPages" />
        </div>
    }
</div>

@if (adBlock(); as adBlock) {
    <packbo-ad-block [adBlock]="adBlock" />
}

<ng-template #emptyState>
    <div class="mb-8 flex h-full flex-col items-center justify-center gap-3">
        <svg-icon
            class="text-primary"
            [svgStyle]="{ width: '400px', height: '400px' }"
            src="assets/icons/Folder-Not-Found.svg"
        />
        <span class="text-title-medium text-center">{{ "category.no_suppliers" | transloco }}</span>
        <span class="text-body-small text-center">{{ "category.no_suppliers_description" | transloco }}</span>
    </div>
</ng-template>
